import React from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'components/Media';

const Quote = styled.blockquote`
  font-size: 1.2rem;
  font-weight: bold;
  line-height: 1.9rem !important;

  &:before {
    content: '\\201C';
    color: ${(props) => props.theme.colors[props.color]};
    font-size: 3em;
    margin-left: -30px;
    position: absolute;

    ${media.down.tablet`
      font-size: 2.2em;
      margin-left: -20px;
    `};
  }

  footer {
    font-size: 1rem;
    font-weight: normal;
  }
`;

Quote.defaultProps = {
  color: 'white'
};

Quote.propTypes = {
  color: PropTypes.string.isRequired
};

export const AuthorImg = styled.img`
  height: 100px;
  max-width: 100px;
  top: 33%;
  ${(props) => (props.right ? 'right: -57px' : 'left: -50px')};
  border: 7px solid ${(props) => props.theme.colors[props.color]};
  position: absolute;
  ${media.down.tablet`
    position: static;
    height: 60px;
    border: 0;
  `};
`;

AuthorImg.propTypes = {
  color: PropTypes.string.isRequired,
  right: PropTypes.bool.isRequired
};

AuthorImg.defaultProps = {
  right: false
};

export default Quote;
